"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.shoppingContextActionEvents = void 0;
var _acceptNotification = require("@ori-events/accept-notification");
var _addBackorderDemand = require("@ori-events/add-backorder-demand");
var _addBasketOffer = require("@ori-events/add-basket-offer");
var _addCatalogueOffer = require("@ori-events/add-catalogue-offer");
var _addCustomerOrder = require("@ori-events/add-customer-order");
var _addFreeShippingOffer = require("@ori-events/add-free-shipping-offer");
var _addPersonalNutritionItems = require("@ori-events/add-personal-nutrition-items");
var _addPersonalSubscription = require("@ori-events/add-personal-subscription");
var _addToBasket = require("@ori-events/add-to-basket");
var _addVoucher = require("@ori-events/add-voucher");
var _cancelBackorderDemand = require("@ori-events/cancel-backorder-demand");
var _cancelSubscription = require("@ori-events/cancel-subscription");
var _clearBasket = require("@ori-events/clear-basket");
var _delaySubscription = require("@ori-events/delay-subscription");
var _deleteOfferItem = require("@ori-events/delete-offer-item");
var _loyaltyDialogResult = require("@ori-events/loyalty-dialog-result");
var _removeBasketItem = require("@ori-events/remove-basket-item");
var _removeCustomerOrder = require("@ori-events/remove-customer-order");
var _removeShippingOfferItem = require("@ori-events/remove-shipping-offer-item");
var _removeVoucher = require("@ori-events/remove-voucher");
var _replaceShoppingBagItem = require("@ori-events/replace-shopping-bag-item");
var _replaceSubscription = require("@ori-events/replace-subscription");
var _requestShoppingContext = require("@ori-events/request-shopping-context");
var _resetShippingSelection = require("@ori-events/reset-shipping-selection");
var _updateBasketItem = require("@ori-events/update-basket-item");
var _updateCustomerOrderItem = require("@ori-events/update-customer-order-item");
var _updateDelivery = require("@ori-events/update-delivery");
var _updateDeliveryChannel = require("@ori-events/update-delivery-channel");
var _updateDonation = require("@ori-events/update-donation");
var _updateOfferItem = require("@ori-events/update-offer-item");
var _updateOfferItems = require("@ori-events/update-offer-items");
var _updatePaymentProvider = require("@ori-events/update-payment-provider");
/**
 * List of all shopping context action triggering event names. The action can
 * be request to load current context data or a data modification request, like
 * add-to-basket etc.
 */
const shoppingContextActionEvents = exports.shoppingContextActionEvents = [_acceptNotification.Name, _addBackorderDemand.Name, _addBasketOffer.Name, _addCatalogueOffer.Name, _addCustomerOrder.Name, _addFreeShippingOffer.Name, _addPersonalNutritionItems.Name, _addPersonalSubscription.AddPersonalSubscription, _addToBasket.Name, _addVoucher.Name, _cancelBackorderDemand.Name, _cancelSubscription.Name, _clearBasket.Name, _delaySubscription.Name, _deleteOfferItem.Name, _loyaltyDialogResult.Name, _removeBasketItem.Name, _removeCustomerOrder.Name, _removeShippingOfferItem.Name, _removeVoucher.Name, _replaceShoppingBagItem.Name, _replaceSubscription.Name, _requestShoppingContext.Name, _resetShippingSelection.Name, _updateBasketItem.Name, _updateCustomerOrderItem.Name, _updateDelivery.Name, _updateDeliveryChannel.Name, _updateDonation.Name, _updateOfferItem.Name, _updateOfferItems.Name, _updatePaymentProvider.Name];

/** Name / type of event which can trigger an action on current shopping context (loading, modification). */